// // import { useState, useRef, useEffect } from 'react';
// // import { Link, NavLink, useNavigate } from 'react-router-dom';
// // import ReactDOM from 'react-dom';
// // import { useAuth } from '../../../hooks/useAuth';
// // import styles from './Navbar.module.scss';

// // const NAV_LINKS = [
// //   { to: '/',               label: 'Home',           protected: false },
// //   { to: '/courts',         label: 'Courts',         protected: false },
// //   { to: '/tournaments',    label: 'Tournaments',    protected: false },
// //   { to: '/coaches',        label: 'Book a Coach',   protected: false },
// //   { to: '/live-matches',   label: 'Live Matches',   protected: false },
// //   { to: '/my-tournaments', label: 'My Tournaments', protected: true  },
// //   { to: '/my-bookings',    label: 'My Bookings',    protected: true  },
// // ];

// // const Portal = ({ children }) =>
// //   ReactDOM.createPortal(children, document.body);

// // /* ══════════════════════════════════════════
// //    LOGOUT POPUP
// // ══════════════════════════════════════════ */
// // const LogoutPopup = ({ onConfirm, onCancel }) => (
// //   <Portal>
// //     <div className={styles.popupOverlay} onClick={onCancel}>
// //       <div className={styles.popupCard} onClick={(e) => e.stopPropagation()}>
// //         <div className={styles.waveHandWrap}>
// //           <span className={styles.waveHand}>👋</span>
// //         </div>
// //         <h3 className={styles.popupTitle}>Leaving so soon?</h3>
// //         <p className={styles.popupMsg}>
// //           Are you sure you want to logout from{' '}
// //           <span className={styles.popupAccent}>SportsMaster</span>?
// //         </p>
// //         <div className={styles.popupActions}>
// //           <button className={styles.popupCancel}  onClick={onCancel}>Stay</button>
// //           <button className={styles.popupConfirm} onClick={onConfirm}>Yes, Logout</button>
// //         </div>
// //       </div>
// //     </div>
// //   </Portal>
// // );

// // /* ══════════════════════════════════════════
// //    LOGIN REQUIRED POPUP
// // ══════════════════════════════════════════ */
// // const LoginRequiredPopup = ({ label, redirectTo, onClose }) => {
// //   const navigate      = useNavigate();
// //   const isTournaments = redirectTo === '/my-tournaments';

// //   const handleLogin = () => {
// //     sessionStorage.setItem('pendingNavRedirect', redirectTo);
// //     navigate('/login?redirect=' + redirectTo);
// //     onClose();
// //   };

// //   const handleSignUp = () => {
// //     sessionStorage.setItem('pendingNavRedirect', redirectTo);
// //     navigate('/register?redirect=' + redirectTo);
// //     onClose();
// //   };

// //   return (
// //     <Portal>
// //       <div className={styles.popupOverlay} onClick={onClose}>
// //         <div className={styles.popupCard} onClick={(e) => e.stopPropagation()}>

// //           {isTournaments ? (
// //             <div className={styles.trophyWrap}>
// //               <div className={styles.trophyCore} />
// //               <div className={styles.trophyRing1} />
// //               <div className={styles.trophyRing2} />
// //               <div className={styles.trophyRing3} />
// //               <div className={styles.trophySparkWrap}>
// //                 {[0,1,2,3,4,5].map((i) => (
// //                   <div key={i} className={styles.trophySpark} style={{ '--si': i }} />
// //                 ))}
// //               </div>
// //             </div>
// //           ) : (
// //             <div className={styles.cardFanWrap}>
// //               <div className={`${styles.fanCard} ${styles.fanCard3}`} />
// //               <div className={`${styles.fanCard} ${styles.fanCard2}`} />
// //               <div className={`${styles.fanCard} ${styles.fanCard1}`} />
// //               <div className={styles.fanDot1} />
// //               <div className={styles.fanDot2} />
// //               <div className={styles.fanDot3} />
// //             </div>
// //           )}

// //           <h3 className={styles.popupTitle}>Login Required</h3>
// //           <p className={styles.popupMsg}>
// //             You need to be logged in to access{' '}
// //             <span className={styles.popupAccent}>{label}</span>
// //           </p>
// //           <div className={styles.popupActions}>
// //             <button className={styles.popupCancel}  onClick={onClose}>Cancel</button>
// //             <button className={styles.popupConfirm} onClick={handleLogin}>Login Now →</button>
// //           </div>
// //           <p className={styles.popupHint}>
// //             Don't have an account?{' '}
// //             <span className={styles.popupHintLink} onClick={handleSignUp}>Sign up free</span>
// //           </p>

// //         </div>
// //       </div>
// //     </Portal>
// //   );
// // };

// // /* ══════════════════════════════════════════
// //    HAMBURGER ICON
// // ══════════════════════════════════════════ */
// // const Hamburger = ({ open, onClick }) => (
// //   <button
// //     type="button"
// //     className={`${styles.hamburger} ${open ? styles.hamburgerOpen : ''}`}
// //     onClick={onClick}
// //     aria-label={open ? 'Close menu' : 'Open menu'}
// //     aria-expanded={open}
// //   >
// //     <span className={styles.bar} />
// //     <span className={styles.bar} />
// //     <span className={styles.bar} />
// //   </button>
// // );

// // /* ══════════════════════════════════════════
// //    NAVBAR
// // ══════════════════════════════════════════ */
// // const Navbar = () => {
// //   const { user, isAuthenticated, logout } = useAuth();
// //   const navigate = useNavigate();

// //   const [dropdownOpen, setDropdownOpen] = useState(false);
// //   const [mobileOpen,   setMobileOpen]   = useState(false);
// //   const [showLogout,   setShowLogout]   = useState(false);
// //   const [authPrompt,   setAuthPrompt]   = useState(null);

// //   const menuRef   = useRef(null);
// //   const mobileRef = useRef(null);

// //   /* close desktop dropdown on outside click */
// //   useEffect(() => {
// //     const handler = (e) => {
// //       if (menuRef.current && !menuRef.current.contains(e.target))
// //         setDropdownOpen(false);
// //     };
// //     document.addEventListener('mousedown', handler);
// //     return () => document.removeEventListener('mousedown', handler);
// //   }, []);

// //   /* close mobile drawer on outside click */
// //   useEffect(() => {
// //     const handler = (e) => {
// //       if (mobileRef.current && !mobileRef.current.contains(e.target))
// //         setMobileOpen(false);
// //     };
// //     document.addEventListener('mousedown', handler);
// //     return () => document.removeEventListener('mousedown', handler);
// //   }, []);

// //   /* Escape key closes everything */
// //   useEffect(() => {
// //     const onKey = (e) => {
// //       if (e.key === 'Escape') {
// //         setShowLogout(false);
// //         setAuthPrompt(null);
// //         setMobileOpen(false);
// //         setDropdownOpen(false);
// //       }
// //     };
// //     window.addEventListener('keydown', onKey);
// //     return () => window.removeEventListener('keydown', onKey);
// //   }, []);

// //   /* lock body scroll when mobile menu is open */
// //   useEffect(() => {
// //     document.body.style.overflow = mobileOpen ? 'hidden' : '';
// //     return () => { document.body.style.overflow = ''; };
// //   }, [mobileOpen]);

// //   /* redirect after login */
// //   useEffect(() => {
// //     if (!isAuthenticated) return;
// //     const pending = sessionStorage.getItem('pendingNavRedirect');
// //     if (!pending) return;
// //     sessionStorage.removeItem('pendingNavRedirect');
// //     navigate(pending);
// //   }, [isAuthenticated]);

// //   const handleLogoutClick = () => {
// //     setDropdownOpen(false);
// //     setMobileOpen(false);
// //     setShowLogout(true);
// //   };

// //   const handleConfirmLogout = () => {
// //     setShowLogout(false);
// //     logout();
// //   };

// //   const handleProtectedClick = (e, link) => {
// //     if (!isAuthenticated) {
// //       e.preventDefault();
// //       setMobileOpen(false);
// //       setAuthPrompt({ label: link.label, redirectTo: link.to });
// //     }
// //   };

// //   const navLinkClass = ({ isActive }, link) =>
// //     [
// //       styles.navItem,
// //       isActive           ? styles.navItemActive : '',
// //       link.protected && !isAuthenticated ? styles.navItemLocked : '',
// //     ].filter(Boolean).join(' ');

// //   return (
// //     <>
// //       <nav className={styles.navbar}>

// //         {/* ── Brand ── */}
// //         <Link to="/" className={styles.brand} onClick={() => setMobileOpen(false)}>
// //           <span className={styles.brandIcon}>🏀</span>
// //           <span className={styles.brandText}>SportsMaster</span>
// //         </Link>

// //         {/* ── Desktop nav links ── */}
// //         <ul className={styles.navLinks}>
// //           {NAV_LINKS.map((link) => (
// //             <li key={link.to}>
// //               <NavLink
// //                 to={link.to}
// //                 end={link.to === '/'}
// //                 className={(s) => navLinkClass(s, link)}
// //                 onClick={(e) => link.protected && handleProtectedClick(e, link)}
// //               >
// //                 {link.label}
// //               </NavLink>
// //             </li>
// //           ))}
// //         </ul>

// //         {/* ── Desktop auth ── */}
// //         <div className={styles.authActions}>
// //           {isAuthenticated ? (
// //             <div className={styles.userMenu} ref={menuRef}>
// //               <div
// //                 className={styles.avatar}
// //                 onClick={() => setDropdownOpen((p) => !p)}
// //                 title={user?.name}
// //               >
// //                 {user?.name?.[0]?.toUpperCase()}
// //               </div>
// //               {dropdownOpen && (
// //                 <div className={styles.dropdown}>
// //                   <Link to="/profile" onClick={() => setDropdownOpen(false)}>
// //                     My Profile
// //                   </Link>
// //                   <button type="button" onClick={handleLogoutClick}>
// //                     Logout
// //                   </button>
// //                 </div>
// //               )}
// //             </div>
// //           ) : (
// //             <Link to="/login" className={styles.btnAuth}>
// //               Login / Register
// //             </Link>
// //           )}
// //         </div>

// //         {/* ── Hamburger (mobile only) ── */}
// //         <Hamburger open={mobileOpen} onClick={() => setMobileOpen((p) => !p)} />

// //       </nav>

// //       {/* ══ MOBILE DRAWER ══ */}
// //       {/* Backdrop */}
// //       <div
// //         className={`${styles.mobileBackdrop} ${mobileOpen ? styles.mobileBackdropOpen : ''}`}
// //         onClick={() => setMobileOpen(false)}
// //         aria-hidden="true"
// //       />

// //       {/* Drawer panel */}
// //       <div
// //         ref={mobileRef}
// //         className={`${styles.mobileDrawer} ${mobileOpen ? styles.mobileDrawerOpen : ''}`}
// //         aria-hidden={!mobileOpen}
// //       >
// //         {/* Drawer header */}
// //         <div className={styles.drawerHeader}>
// //           <Link to="/" className={styles.brand} onClick={() => setMobileOpen(false)}>
// //             <span className={styles.brandIcon}>🏀</span>
// //             <span className={styles.brandText}>SportsMaster</span>
// //           </Link>
// //           <button
// //             type="button"
// //             className={styles.drawerClose}
// //             onClick={() => setMobileOpen(false)}
// //             aria-label="Close menu"
// //           >
// //             ✕
// //           </button>
// //         </div>

// //         {/* Drawer nav links */}
// //         <ul className={styles.drawerLinks}>
// //           {NAV_LINKS.map((link) => (
// //             <li key={link.to}>
// //               <NavLink
// //                 to={link.to}
// //                 end={link.to === '/'}
// //                 className={(s) => `${styles.drawerItem} ${s.isActive ? styles.drawerItemActive : ''} ${link.protected && !isAuthenticated ? styles.drawerItemLocked : ''}`}
// //                 onClick={(e) => {
// //                   if (link.protected && !isAuthenticated) {
// //                     handleProtectedClick(e, link);
// //                   } else {
// //                     setMobileOpen(false);
// //                   }
// //                 }}
// //               >
// //                 <span className={styles.drawerItemLabel}>{link.label}</span>
// //                 {link.protected && !isAuthenticated && (
// //                   <span className={styles.drawerLock}>🔒</span>
// //                 )}
// //               </NavLink>
// //             </li>
// //           ))}
// //         </ul>

// //         {/* Drawer footer auth */}
// //         <div className={styles.drawerFooter}>
// //           {isAuthenticated ? (
// //             <>
// //               <Link
// //                 to="/profile"
// //                 className={styles.drawerProfileBtn}
// //                 onClick={() => setMobileOpen(false)}
// //               >
// //                 <span className={styles.drawerAvatar}>
// //                   {user?.name?.[0]?.toUpperCase()}
// //                 </span>
// //                 <span>{user?.name}</span>
// //               </Link>
// //               <button
// //                 type="button"
// //                 className={styles.drawerLogoutBtn}
// //                 onClick={handleLogoutClick}
// //               >
// //                 Logout
// //               </button>
// //             </>
// //           ) : (
// //             <Link
// //               to="/login"
// //               className={styles.drawerAuthBtn}
// //               onClick={() => setMobileOpen(false)}
// //             >
// //               Login / Register
// //             </Link>
// //           )}
// //         </div>
// //       </div>

// //       {/* ══ POPUPS ══ */}
// //       {showLogout && (
// //         <LogoutPopup
// //           onConfirm={handleConfirmLogout}
// //           onCancel={() => setShowLogout(false)}
// //         />
// //       )}

// //       {authPrompt && (
// //         <LoginRequiredPopup
// //           label={authPrompt.label}
// //           redirectTo={authPrompt.redirectTo}
// //           onClose={() => setAuthPrompt(null)}
// //         />
// //       )}
// //     </>
// //   );
// // };

// // export default Navbar;
// // import { useState, useRef, useEffect } from 'react';
// // import { Link, NavLink, useNavigate } from 'react-router-dom';
// // import ReactDOM from 'react-dom';
// // import { useAuth } from '../../../hooks/useAuth';
// // import styles from './Navbar.module.scss';

// // /* ─────────────────────────────────
// //    NAV LINKS
// // ───────────────────────────────── */
// // const NAV_LINKS = [
// //   { to: '/',                label: 'Home',           protected: false },
// //   { to: '/courts',          label: 'Courts',         protected: false },
// //   { to: '/tournaments',     label: 'Tournaments',    protected: false },
// //   { to: '/coaches',         label: 'Book a Coach',   protected: false },
// //   { to: '/book-one-on-one', label: 'Book 1-on-1',    protected: false },
// //   { to: '/live-matches',    label: 'Live Matches',   protected: false },
// //   { to: '/my-tournaments',  label: 'My Tournaments', protected: true  },
// //   { to: '/my-bookings',     label: 'My Bookings',    protected: true  },
// // ];

// // /* ─────────────────────────────────
// //    MOCK NOTIFICATIONS
// // ───────────────────────────────── */
// // const MOCK_NOTIFICATIONS = [
// //   {
// //     id: 1,
// //     type: 'court_approved',
// //     icon: '🏟️',
// //     title: 'Court Booking Approved',
// //     message: 'Your booking for Badminton Court A on Apr 2 has been approved by the vendor.',
// //     time: '2 min ago',
// //     read: false,
// //   },
// //   {
// //     id: 2,
// //     type: 'tournament_registered',
// //     icon: '🏆',
// //     title: 'Tournament Registration Confirmed',
// //     message: 'You have successfully registered for the Summer Badminton Championship 2026.',
// //     time: '15 min ago',
// //     read: false,
// //   },
// //   {
// //     id: 3,
// //     type: 'coach_approved',
// //     icon: '🎯',
// //     title: 'Coach Session Approved',
// //     message: 'Coach Rahul has accepted your 1-on-1 session request for Saturday, 10 AM.',
// //     time: '1 hr ago',
// //     read: false,
// //   },
// //   {
// //     id: 4,
// //     type: 'player_registered',
// //     icon: '👤',
// //     title: 'Player Profile Verified',
// //     message: 'Your player profile has been verified. You can now join ranked tournaments.',
// //     time: '3 hr ago',
// //     read: true,
// //   },
// //   {
// //     id: 5,
// //     type: 'court_rejected',
// //     icon: '❌',
// //     title: 'Court Booking Rejected',
// //     message: 'Your booking for Tennis Court B on Apr 5 was declined. Please choose another slot.',
// //     time: 'Yesterday',
// //     read: true,
// //   },
// //   {
// //     id: 6,
// //     type: 'tournament_registered',
// //     icon: '🏆',
// //     title: 'Tournament Draw Published',
// //     message: 'The draw for Spring Table Tennis Open is live. Check your bracket now.',
// //     time: '2 days ago',
// //     read: true,
// //   },
// // ];

// // /* ─────────────────────────────────
// //    PORTAL
// // ───────────────────────────────── */
// // const Portal = ({ children }) =>
// //   ReactDOM.createPortal(children, document.body);

// // /* ─────────────────────────────────
// //    BELL ICON SVG
// // ───────────────────────────────── */
// // const BellIcon = () => (
// //   <svg
// //     width="18" height="18"
// //     viewBox="0 0 24 24"
// //     fill="none"
// //     stroke="currentColor"
// //     strokeWidth="2"
// //     strokeLinecap="round"
// //     strokeLinejoin="round"
// //   >
// //     <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
// //     <path d="M13.73 21a2 2 0 0 1-3.46 0" />
// //   </svg>
// // );

// // /* ══════════════════════════════════════════
// //    NOTIFICATION PANEL
// // ══════════════════════════════════════════ */
// // const NotificationPanel = ({ notifications, onRead, onReadAll, onClose, panelRef }) => {
// //   const unreadCount = notifications.filter((n) => !n.read).length;

// //   return (
// //     <div className={styles.notifPanel} ref={panelRef}>
// //       {/* Header */}
// //       <div className={styles.notifHeader}>
// //         <div className={styles.notifHeaderLeft}>
// //           <span className={styles.notifTitle}>Notifications</span>
// //           {unreadCount > 0 && (
// //             <span className={styles.notifHeaderBadge}>{unreadCount} new</span>
// //           )}
// //         </div>
// //         {unreadCount > 0 && (
// //           <button className={styles.notifMarkAll} onClick={onReadAll}>
// //             Mark all read
// //           </button>
// //         )}
// //       </div>

// //       {/* List */}
// //       <ul className={styles.notifList}>
// //         {notifications.length === 0 ? (
// //           <li className={styles.notifEmpty}>
// //             <span className={styles.notifEmptyIcon}>🔔</span>
// //             <span>No notifications yet</span>
// //           </li>
// //         ) : (
// //           notifications.map((n) => (
// //             <li
// //               key={n.id}
// //               className={`${styles.notifItem}${!n.read ? ' ' + styles.notifItemUnread : ''}`}
// //               onClick={() => onRead(n.id)}
// //             >
// //               <div className={`${styles.notifIconWrap} ${styles['notifType_' + n.type]}`}>
// //                 {n.icon}
// //               </div>
// //               <div className={styles.notifBody}>
// //                 <p className={styles.notifItemTitle}>{n.title}</p>
// //                 <p className={styles.notifItemMsg}>{n.message}</p>
// //                 <span className={styles.notifTime}>{n.time}</span>
// //               </div>
// //               {!n.read && <span className={styles.notifDot} />}
// //             </li>
// //           ))
// //         )}
// //       </ul>

// //       {/* Footer */}
// //       {notifications.length > 0 && (
// //         <div className={styles.notifFooter}>
// //           <Link to="/notifications" className={styles.notifViewAll} onClick={onClose}>
// //             View all notifications →
// //           </Link>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // /* ══════════════════════════════════════════
// //    NOTIFICATION BELL BUTTON
// // ══════════════════════════════════════════ */
// // const NotifBell = ({ notifications, onNotifChange }) => {
// //   const [open, setOpen]       = useState(false);
// //   const panelRef              = useRef(null);
// //   const bellRef               = useRef(null);
// //   const unreadCount           = notifications.filter((n) => !n.read).length;

// //   /* close on outside click */
// //   useEffect(() => {
// //     const handler = (e) => {
// //       if (
// //         panelRef.current  && !panelRef.current.contains(e.target) &&
// //         bellRef.current   && !bellRef.current.contains(e.target)
// //       ) {
// //         setOpen(false);
// //       }
// //     };
// //     document.addEventListener('mousedown', handler);
// //     return () => document.removeEventListener('mousedown', handler);
// //   }, []);

// //   const handleRead = (id) => {
// //     onNotifChange((prev) =>
// //       prev.map((n) => (n.id === id ? { ...n, read: true } : n))
// //     );
// //   };

// //   const handleReadAll = () => {
// //     onNotifChange((prev) => prev.map((n) => ({ ...n, read: true })));
// //   };

// //   return (
// //     <div className={styles.notifWrap} ref={bellRef}>
// //       <button
// //         type="button"
// //         className={`${styles.notifBell}${open ? ' ' + styles.notifBellActive : ''}`}
// //         onClick={() => setOpen((p) => !p)}
// //         aria-label="Notifications"
// //       >
// //         <BellIcon />
// //         {unreadCount > 0 && (
// //           <span className={styles.notifBadge}>
// //             {unreadCount > 9 ? '9+' : unreadCount}
// //           </span>
// //         )}
// //       </button>

// //       {open && (
// //         <NotificationPanel
// //           notifications={notifications}
// //           onRead={handleRead}
// //           onReadAll={handleReadAll}
// //           onClose={() => setOpen(false)}
// //           panelRef={panelRef}
// //         />
// //       )}
// //     </div>
// //   );
// // };

// // /* ══════════════════════════════════════════
// //    LOGOUT POPUP
// // ══════════════════════════════════════════ */
// // const LogoutPopup = ({ onConfirm, onCancel }) => (
// //   <Portal>
// //     <div className={styles.popupOverlay} onClick={onCancel}>
// //       <div className={styles.popupCard} onClick={(e) => e.stopPropagation()}>
// //         <div className={styles.waveHandWrap}>
// //           <span className={styles.waveHand}>👋</span>
// //         </div>
// //         <h3 className={styles.popupTitle}>Leaving so soon?</h3>
// //         <p className={styles.popupMsg}>
// //           Are you sure you want to logout from{' '}
// //           <span className={styles.popupAccent}>SportsMaster</span>?
// //         </p>
// //         <div className={styles.popupActions}>
// //           <button className={styles.popupCancel}  onClick={onCancel}>Stay</button>
// //           <button className={styles.popupConfirm} onClick={onConfirm}>Yes, Logout</button>
// //         </div>
// //       </div>
// //     </div>
// //   </Portal>
// // );

// // /* ══════════════════════════════════════════
// //    LOGIN REQUIRED POPUP
// // ══════════════════════════════════════════ */
// // const LoginRequiredPopup = ({ label, redirectTo, onClose }) => {
// //   const navigate      = useNavigate();
// //   const isTournaments = redirectTo === '/my-tournaments';

// //   const handleLogin = () => {
// //     sessionStorage.setItem('pendingNavRedirect', redirectTo);
// //     navigate('/login?redirect=' + redirectTo);
// //     onClose();
// //   };

// //   const handleSignUp = () => {
// //     sessionStorage.setItem('pendingNavRedirect', redirectTo);
// //     navigate('/register?redirect=' + redirectTo);
// //     onClose();
// //   };

// //   return (
// //     <Portal>
// //       <div className={styles.popupOverlay} onClick={onClose}>
// //         <div className={styles.popupCard} onClick={(e) => e.stopPropagation()}>

// //           {isTournaments ? (
// //             <div className={styles.trophyWrap}>
// //               <div className={styles.trophyCore} />
// //               <div className={styles.trophyRing1} />
// //               <div className={styles.trophyRing2} />
// //               <div className={styles.trophyRing3} />
// //               <div className={styles.trophySparkWrap}>
// //                 {[0,1,2,3,4,5].map((i) => (
// //                   <div key={i} className={styles.trophySpark} style={{ '--si': i }} />
// //                 ))}
// //               </div>
// //             </div>
// //           ) : (
// //             <div className={styles.cardFanWrap}>
// //               <div className={`${styles.fanCard} ${styles.fanCard3}`} />
// //               <div className={`${styles.fanCard} ${styles.fanCard2}`} />
// //               <div className={`${styles.fanCard} ${styles.fanCard1}`} />
// //               <div className={styles.fanDot1} />
// //               <div className={styles.fanDot2} />
// //               <div className={styles.fanDot3} />
// //             </div>
// //           )}

// //           <h3 className={styles.popupTitle}>Login Required</h3>
// //           <p className={styles.popupMsg}>
// //             You need to be logged in to access{' '}
// //             <span className={styles.popupAccent}>{label}</span>
// //           </p>
// //           <div className={styles.popupActions}>
// //             <button className={styles.popupCancel}  onClick={onClose}>Cancel</button>
// //             <button className={styles.popupConfirm} onClick={handleLogin}>Login Now →</button>
// //           </div>
// //           <p className={styles.popupHint}>
// //             Don't have an account?{' '}
// //             <span className={styles.popupHintLink} onClick={handleSignUp}>Sign up free</span>
// //           </p>
// //         </div>
// //       </div>
// //     </Portal>
// //   );
// // };

// // /* ══════════════════════════════════════════
// //    HAMBURGER
// // ══════════════════════════════════════════ */
// // const Hamburger = ({ open, onClick }) => (
// //   <button
// //     type="button"
// //     className={`${styles.hamburger}${open ? ' ' + styles.hamburgerOpen : ''}`}
// //     onClick={onClick}
// //     aria-label={open ? 'Close menu' : 'Open menu'}
// //     aria-expanded={open}
// //   >
// //     <span className={styles.bar} />
// //     <span className={styles.bar} />
// //     <span className={styles.bar} />
// //   </button>
// // );

// // /* ══════════════════════════════════════════
// //    NAVBAR
// // ══════════════════════════════════════════ */
// // const Navbar = () => {
// //   const { user, isAuthenticated, logout } = useAuth();
// //   const navigate = useNavigate();

// //   const [dropdownOpen,   setDropdownOpen]   = useState(false);
// //   const [mobileOpen,     setMobileOpen]     = useState(false);
// //   const [showLogout,     setShowLogout]     = useState(false);
// //   const [authPrompt,     setAuthPrompt]     = useState(null);
// //   const [notifications,  setNotifications]  = useState(MOCK_NOTIFICATIONS);
// //   /* mobile notification panel */
// //   const [mobileNotifOpen, setMobileNotifOpen] = useState(false);

// //   const menuRef          = useRef(null);
// //   const mobileRef        = useRef(null);
// //   const mobileNotifRef   = useRef(null);

// //   /* close desktop dropdown on outside click */
// //   useEffect(() => {
// //     const handler = (e) => {
// //       if (menuRef.current && !menuRef.current.contains(e.target))
// //         setDropdownOpen(false);
// //     };
// //     document.addEventListener('mousedown', handler);
// //     return () => document.removeEventListener('mousedown', handler);
// //   }, []);

// //   /* close mobile drawer on outside click */
// //   useEffect(() => {
// //     const handler = (e) => {
// //       if (mobileRef.current && !mobileRef.current.contains(e.target))
// //         setMobileOpen(false);
// //     };
// //     document.addEventListener('mousedown', handler);
// //     return () => document.removeEventListener('mousedown', handler);
// //   }, []);

// //   /* close mobile notif panel on outside click */
// //   useEffect(() => {
// //     if (!mobileNotifOpen) return;
// //     const handler = (e) => {
// //       if (mobileNotifRef.current && !mobileNotifRef.current.contains(e.target))
// //         setMobileNotifOpen(false);
// //     };
// //     document.addEventListener('mousedown', handler);
// //     return () => document.removeEventListener('mousedown', handler);
// //   }, [mobileNotifOpen]);

// //   /* Escape key closes everything */
// //   useEffect(() => {
// //     const onKey = (e) => {
// //       if (e.key === 'Escape') {
// //         setShowLogout(false);
// //         setAuthPrompt(null);
// //         setMobileOpen(false);
// //         setDropdownOpen(false);
// //         setMobileNotifOpen(false);
// //       }
// //     };
// //     window.addEventListener('keydown', onKey);
// //     return () => window.removeEventListener('keydown', onKey);
// //   }, []);

// //   /* lock body scroll when mobile menu or notif open */
// //   useEffect(() => {
// //     document.body.style.overflow = mobileOpen ? 'hidden' : '';
// //     return () => { document.body.style.overflow = ''; };
// //   }, [mobileOpen]);

// //   /* redirect after login */
// //   useEffect(() => {
// //     if (!isAuthenticated) return;
// //     const pending = sessionStorage.getItem('pendingNavRedirect');
// //     if (!pending) return;
// //     sessionStorage.removeItem('pendingNavRedirect');
// //     navigate(pending);
// //   }, [isAuthenticated]);

// //   const handleLogoutClick = () => {
// //     setDropdownOpen(false);
// //     setMobileOpen(false);
// //     setShowLogout(true);
// //   };

// //   const handleConfirmLogout = () => {
// //     setShowLogout(false);
// //     logout();
// //   };

// //   const handleProtectedClick = (e, link) => {
// //     if (!isAuthenticated) {
// //       e.preventDefault();
// //       setMobileOpen(false);
// //       setAuthPrompt({ label: link.label, redirectTo: link.to });
// //     }
// //   };

// //   const navLinkClass = ({ isActive }, link) =>
// //     [
// //       styles.navItem,
// //       isActive ? styles.navItemActive : '',
// //       link.protected && !isAuthenticated ? styles.navItemLocked : '',
// //     ].filter(Boolean).join(' ');

// //   const unreadCount = notifications.filter((n) => !n.read).length;

// //   const handleMobileNotifRead = (id) => {
// //     setNotifications((prev) =>
// //       prev.map((n) => (n.id === id ? { ...n, read: true } : n))
// //     );
// //   };

// //   const handleMobileNotifReadAll = () => {
// //     setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
// //   };

// //   return (
// //     <>
// //       <nav className={styles.navbar}>

// //         {/* ── Brand ── */}
// //         <Link to="/" className={styles.brand} onClick={() => setMobileOpen(false)}>
// //           <span className={styles.brandIcon}>🏀</span>
// //           <span className={styles.brandText}>SportsMaster</span>
// //         </Link>

// //         {/* ── Desktop nav links ── */}
// //         <ul className={styles.navLinks}>
// //           {NAV_LINKS.map((link) => (
// //             <li key={link.to}>
// //               <NavLink
// //                 to={link.to}
// //                 end={link.to === '/'}
// //                 className={(s) => navLinkClass(s, link)}
// //                 onClick={(e) => link.protected && handleProtectedClick(e, link)}
// //               >
// //                 {link.label}
// //               </NavLink>
// //             </li>
// //           ))}
// //         </ul>

// //         {/* ── Desktop auth + notification ── */}
// //         <div className={styles.authActions}>
// //           {isAuthenticated ? (
// //             <>
// //               {/* Notification Bell */}
// //               <NotifBell
// //                 notifications={notifications}
// //                 onNotifChange={setNotifications}
// //               />

// //               {/* Avatar dropdown */}
// //               <div className={styles.userMenu} ref={menuRef}>
// //                 <div
// //                   className={styles.avatar}
// //                   onClick={() => setDropdownOpen((p) => !p)}
// //                   title={user?.name}
// //                 >
// //                   {user?.name?.[0]?.toUpperCase()}
// //                 </div>
// //                 {dropdownOpen && (
// //                   <div className={styles.dropdown}>
// //                     <Link to="/profile" onClick={() => setDropdownOpen(false)}>
// //                       My Profile
// //                     </Link>
// //                     <button type="button" onClick={handleLogoutClick}>
// //                       Logout
// //                     </button>
// //                   </div>
// //                 )}
// //               </div>
// //             </>
// //           ) : (
// //             <Link to="/login" className={styles.btnAuth}>
// //               Login / Register
// //             </Link>
// //           )}
// //         </div>

// //         {/* ── Mobile right cluster ── */}
// //         <div className={styles.mobileRight}>
// //           {isAuthenticated && (
// //             <button
// //               type="button"
// //               className={`${styles.notifBell}${mobileNotifOpen ? ' ' + styles.notifBellActive : ''}`}
// //               onClick={() => setMobileNotifOpen((p) => !p)}
// //               aria-label="Notifications"
// //             >
// //               <BellIcon />
// //               {unreadCount > 0 && (
// //                 <span className={styles.notifBadge}>
// //                   {unreadCount > 9 ? '9+' : unreadCount}
// //                 </span>
// //               )}
// //             </button>
// //           )}
// //           <Hamburger open={mobileOpen} onClick={() => setMobileOpen((p) => !p)} />
// //         </div>

// //       </nav>

// //       {/* ══ MOBILE NOTIFICATION PANEL (portal, slides from top-right) ══ */}
// //       {isAuthenticated && mobileNotifOpen && (
// //         <Portal>
// //           <div
// //             className={styles.mobileNotifOverlay}
// //             onClick={() => setMobileNotifOpen(false)}
// //           />
// //           <div className={styles.mobileNotifSheet} ref={mobileNotifRef}>
// //             <NotificationPanel
// //               notifications={notifications}
// //               onRead={handleMobileNotifRead}
// //               onReadAll={handleMobileNotifReadAll}
// //               onClose={() => setMobileNotifOpen(false)}
// //             />
// //           </div>
// //         </Portal>
// //       )}

// //       {/* ══ MOBILE DRAWER ══ */}
// //       <div
// //         className={`${styles.mobileBackdrop}${mobileOpen ? ' ' + styles.mobileBackdropOpen : ''}`}
// //         onClick={() => setMobileOpen(false)}
// //         aria-hidden="true"
// //       />

// //       <div
// //         ref={mobileRef}
// //         className={`${styles.mobileDrawer}${mobileOpen ? ' ' + styles.mobileDrawerOpen : ''}`}
// //         aria-hidden={!mobileOpen}
// //       >
// //         {/* Drawer header */}
// //         <div className={styles.drawerHeader}>
// //           <Link to="/" className={styles.brand} onClick={() => setMobileOpen(false)}>
// //             <span className={styles.brandIcon}>🏀</span>
// //             <span className={styles.brandText}>SportsMaster</span>
// //           </Link>
// //           <button
// //             type="button"
// //             className={styles.drawerClose}
// //             onClick={() => setMobileOpen(false)}
// //             aria-label="Close menu"
// //           >
// //             ✕
// //           </button>
// //         </div>

// //         {/* Drawer nav links */}
// //         <ul className={styles.drawerLinks}>
// //           {NAV_LINKS.map((link) => (
// //             <li key={link.to}>
// //               <NavLink
// //                 to={link.to}
// //                 end={link.to === '/'}
// //                 className={(s) =>
// //                   `${styles.drawerItem} ${s.isActive ? styles.drawerItemActive : ''} ${
// //                     link.protected && !isAuthenticated ? styles.drawerItemLocked : ''
// //                   }`
// //                 }
// //                 onClick={(e) => {
// //                   if (link.protected && !isAuthenticated) {
// //                     handleProtectedClick(e, link);
// //                   } else {
// //                     setMobileOpen(false);
// //                   }
// //                 }}
// //               >
// //                 <span className={styles.drawerItemLabel}>{link.label}</span>
// //                 {link.protected && !isAuthenticated && (
// //                   <span className={styles.drawerLock}>🔒</span>
// //                 )}
// //               </NavLink>
// //             </li>
// //           ))}
// //         </ul>

// //         {/* Drawer footer */}
// //         <div className={styles.drawerFooter}>
// //           {isAuthenticated ? (
// //             <>
// //               <Link
// //                 to="/profile"
// //                 className={styles.drawerProfileBtn}
// //                 onClick={() => setMobileOpen(false)}
// //               >
// //                 <span className={styles.drawerAvatar}>
// //                   {user?.name?.[0]?.toUpperCase()}
// //                 </span>
// //                 <span>{user?.name}</span>
// //               </Link>
// //               <button
// //                 type="button"
// //                 className={styles.drawerLogoutBtn}
// //                 onClick={handleLogoutClick}
// //               >
// //                 Logout
// //               </button>
// //             </>
// //           ) : (
// //             <Link
// //               to="/login"
// //               className={styles.drawerAuthBtn}
// //               onClick={() => setMobileOpen(false)}
// //             >
// //               Login / Register
// //             </Link>
// //           )}
// //         </div>
// //       </div>

// //       {/* ══ POPUPS ══ */}
// //       {showLogout && (
// //         <LogoutPopup
// //           onConfirm={handleConfirmLogout}
// //           onCancel={() => setShowLogout(false)}
// //         />
// //       )}

// //       {authPrompt && (
// //         <LoginRequiredPopup
// //           label={authPrompt.label}
// //           redirectTo={authPrompt.redirectTo}
// //           onClose={() => setAuthPrompt(null)}
// //         />
// //       )}
// //     </>
// //   );
// // };

// // export default Navbar;
// import { useState, useRef, useEffect, useCallback } from 'react';
// import { Link, NavLink, useNavigate }                from 'react-router-dom';
// import ReactDOM                                       from 'react-dom';
// import { useAuth }                                    from '../../../hooks/useAuth';
// import styles                                         from './Navbar.module.scss';


// /* ═══════════════════════════════════════════════════
//    STATIC DATA
// ═══════════════════════════════════════════════════ */
// const NAV_LINKS = [
//   { to: '/',                label: 'Home',           protected: false },
//   { to: '/courts',          label: 'Courts',         protected: false },
//   { to: '/tournaments',     label: 'Tournaments',    protected: false },
//   { to: '/coaches',         label: 'Book a Coach',   protected: false },
//   { to: '/book-one-on-one', label: 'Book 1-on-1',    protected: false },
//   { to: '/live-matches',    label: 'Live Matches',   protected: false },
//   { to: '/my-tournaments',  label: 'My Tournaments', protected: true  },
//   { to: '/my-bookings',     label: 'My Bookings',    protected: true  },
// ];

// const MOCK_NOTIFICATIONS = [
//   {
//     id: 1,
//     type: 'court_approved',
//     icon: '🏟️',
//     title: 'Court Booking Approved',
//     message: 'Your booking for Badminton Court A on Apr 2 has been approved by the vendor.',
//     time: '2 min ago',
//     read: false,
//   },
//   {
//     id: 2,
//     type: 'tournament_registered',
//     icon: '🏆',
//     title: 'Tournament Registration Confirmed',
//     message: 'You have successfully registered for the Summer Badminton Championship 2026.',
//     time: '15 min ago',
//     read: false,
//   },
//   {
//     id: 3,
//     type: 'coach_approved',
//     icon: '🎯',
//     title: 'Coach Session Approved',
//     message: 'Coach Rahul has accepted your 1-on-1 session request for Saturday, 10 AM.',
//     time: '1 hr ago',
//     read: false,
//   },
//   {
//     id: 4,
//     type: 'player_registered',
//     icon: '👤',
//     title: 'Player Profile Verified',
//     message: 'Your player profile has been verified. You can now join ranked tournaments.',
//     time: '3 hr ago',
//     read: true,
//   },
//   {
//     id: 5,
//     type: 'court_rejected',
//     icon: '❌',
//     title: 'Court Booking Rejected',
//     message: 'Your booking for Tennis Court B on Apr 5 was declined. Please choose another slot.',
//     time: 'Yesterday',
//     read: true,
//   },
//   {
//     id: 6,
//     type: 'tournament_registered',
//     icon: '🏆',
//     title: 'Tournament Draw Published',
//     message: 'The draw for Spring Table Tennis Open is live. Check your bracket now.',
//     time: '2 days ago',
//     read: true,
//   },
// ];

// const STORE_FEATURES = ['✓ Free Download', '✓ No Ads', '✓ Live Scores'];


// /* ═══════════════════════════════════════════════════
//    PORTAL
// ═══════════════════════════════════════════════════ */
// const Portal = ({ children }) =>
//   ReactDOM.createPortal(children, document.body);


// /* ═══════════════════════════════════════════════════
//    ICONS
// ═══════════════════════════════════════════════════ */
// const BellIcon = ({ size = 18 }) => (
//   <svg
//     width={size} height={size}
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
//     <path d="M13.73 21a2 2 0 0 1-3.46 0" />
//   </svg>
// );

// const UserIcon = ({ size = 15 }) => (
//   <svg
//     width={size} height={size}
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
//     <circle cx="12" cy="7" r="4" />
//   </svg>
// );

// const LogoutIcon = ({ size = 15 }) => (
//   <svg
//     width={size} height={size}
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
//     <polyline points="16 17 21 12 16 7" />
//     <line x1="21" y1="12" x2="9" y2="12" />
//   </svg>
// );


// /* ═══════════════════════════════════════════════════
//    NOTIFICATION PANEL
// ═══════════════════════════════════════════════════ */
// const NotificationPanel = ({ notifications, onRead, onReadAll, onClose, panelRef }) => {
//   const unreadCount = notifications.filter((n) => !n.read).length;

//   return (
//     <div className={styles.notifPanel} ref={panelRef}>

//       {/* Header */}
//       <div className={styles.notifHeader}>
//         <div className={styles.notifHeaderLeft}>
//           <span className={styles.notifTitle}>Notifications</span>
//           {unreadCount > 0 && (
//             <span className={styles.notifHeaderBadge}>{unreadCount} new</span>
//           )}
//         </div>
//         {unreadCount > 0 && (
//           <button
//             type="button"
//             className={styles.notifMarkAll}
//             onClick={onReadAll}
//           >
//             Mark all read
//           </button>
//         )}
//       </div>

//       {/* List */}
//       <ul className={styles.notifList}>
//         {notifications.length === 0 ? (
//           <li className={styles.notifEmpty}>
//             <span className={styles.notifEmptyIcon}>🔔</span>
//             <span>No notifications yet</span>
//           </li>
//         ) : (
//           notifications.map((n) => (
//             <li
//               key={n.id}
//               className={[
//                 styles.notifItem,
//                 !n.read ? styles.notifItemUnread : '',
//               ]
//                 .filter(Boolean)
//                 .join(' ')}
//               onClick={() => onRead(n.id)}
//             >
//               <div
//                 className={[
//                   styles.notifIconWrap,
//                   styles[`notifType_${n.type}`],
//                 ]
//                   .filter(Boolean)
//                   .join(' ')}
//               >
//                 {n.icon}
//               </div>
//               <div className={styles.notifBody}>
//                 <p className={styles.notifItemTitle}>{n.title}</p>
//                 <p className={styles.notifItemMsg}>{n.message}</p>
//                 <span className={styles.notifTime}>{n.time}</span>
//               </div>
//               {!n.read && <span className={styles.notifDot} />}
//             </li>
//           ))
//         )}
//       </ul>

//       {/* Footer */}
//       {notifications.length > 0 && (
//         <div className={styles.notifFooter}>
//           <Link
//             to="/notifications"
//             className={styles.notifViewAll}
//             onClick={onClose}
//           >
//             View all notifications →
//           </Link>
//         </div>
//       )}
//     </div>
//   );
// };


// /* ═══════════════════════════════════════════════════
//    NOTIFICATION BELL (desktop)
// ═══════════════════════════════════════════════════ */
// const NotifBell = ({ notifications, onNotifChange }) => {
//   const [open,  setOpen]  = useState(false);
//   const bellRef           = useRef(null);
//   const panelRef          = useRef(null);
//   const unreadCount       = notifications.filter((n) => !n.read).length;

//   useEffect(() => {
//     const handler = (e) => {
//       if (
//         panelRef.current && !panelRef.current.contains(e.target) &&
//         bellRef.current  && !bellRef.current.contains(e.target)
//       ) setOpen(false);
//     };
//     document.addEventListener('mousedown', handler);
//     return () => document.removeEventListener('mousedown', handler);
//   }, []);

//   return (
//     <div className={styles.notifWrap} ref={bellRef}>
//       <button
//         type="button"
//         className={[
//           styles.notifBell,
//           open ? styles.notifBellActive : '',
//         ]
//           .filter(Boolean)
//           .join(' ')}
//         onClick={() => setOpen((p) => !p)}
//         aria-label="Notifications"
//       >
//         <BellIcon size={16} />
//         {unreadCount > 0 && (
//           <span className={styles.notifBadge}>
//             {unreadCount > 9 ? '9+' : unreadCount}
//           </span>
//         )}
//       </button>

//       {open && (
//         <NotificationPanel
//           notifications={notifications}
//           panelRef={panelRef}
//           onRead={(id) =>
//             onNotifChange((p) =>
//               p.map((n) => (n.id === id ? { ...n, read: true } : n))
//             )
//           }
//           onReadAll={() =>
//             onNotifChange((p) => p.map((n) => ({ ...n, read: true })))
//           }
//           onClose={() => setOpen(false)}
//         />
//       )}
//     </div>
//   );
// };


// /* ═══════════════════════════════════════════════════
//    PHONE MOCKUP
// ═══════════════════════════════════════════════════ */
// const PhoneMockup = () => (
//   <div className={styles.phoneMockupWrap}>
//     <div className={styles.phoneRing3} />
//     <div className={styles.phoneRing2} />
//     <div className={styles.phoneRing1} />

//     <div className={styles.phone}>
//       <div className={styles.phoneNotch} />
//       <div className={styles.phoneScreen}>
//         <div className={styles.phoneStatusBar}>
//           <span>9:41</span>
//           <span>●●●</span>
//         </div>
//         <div className={styles.phoneHeader}>
//           <span className={styles.phoneHeaderIcon}>🏀</span>
//           <span className={styles.phoneHeaderText}>SportsMaster</span>
//         </div>
//         <div className={styles.phoneBanner} />
//         <div className={styles.phoneCardRow}>
//           <div className={styles.phoneMiniCard} />
//           <div className={styles.phoneMiniCard} />
//         </div>
//         <div className={styles.phoneCardLong} />
//         <div
//           className={styles.phoneCardLong}
//           style={{ opacity: 0.5, width: '70%' }}
//         />
//       </div>
//       <div className={styles.phoneBottomNav}>
//         {['🏠', '🏟️', '🏆', '👤'].map((ic, i) => (
//           <span
//             key={i}
//             className={[
//               styles.phoneNavIcon,
//               i === 0 ? styles.phoneNavIconActive : '',
//             ]
//               .filter(Boolean)
//               .join(' ')}
//           >
//             {ic}
//           </span>
//         ))}
//       </div>
//     </div>

//     <div className={styles.phoneGlow} />
//   </div>
// );


// /* ═══════════════════════════════════════════════════
//    STAR RATING
// ═══════════════════════════════════════════════════ */
// const StarRating = ({ value, count }) => (
//   <div className={styles.storeStarsRow}>
//     <div className={styles.storeStarsInner}>
//       {[1, 2, 3, 4, 5].map((s) => (
//         <span
//           key={s}
//           className={[
//             styles.storeStar,
//             s <= Math.floor(value)
//               ? styles.storeStarFull
//               : s - 0.5 <= value
//               ? styles.storeStarHalf
//               : styles.storeStarEmpty,
//           ]
//             .filter(Boolean)
//             .join(' ')}
//           style={{ '--delay': `${s * 0.08}s` }}
//         >
//           ★
//         </span>
//       ))}
//     </div>
//     <span className={styles.storeStarVal}>{value}</span>
//     <span className={styles.storeStarCount}>({count})</span>
//   </div>
// );


// /* ═══════════════════════════════════════════════════
//    GET APP POPUP
// ═══════════════════════════════════════════════════ */
// const GetAppPopup = ({ onClose }) => {
//   const [entered, setEntered] = useState(false);

//   useEffect(() => {
//     const t = setTimeout(() => setEntered(true), 30);
//     return () => clearTimeout(t);
//   }, []);

//   useEffect(() => {
//     const fn = (e) => e.key === 'Escape' && onClose();
//     window.addEventListener('keydown', fn);
//     return () => window.removeEventListener('keydown', fn);
//   }, [onClose]);

//   return (
//     <Portal>
//       <div
//         className={[
//           styles.getAppOverlay,
//           entered ? styles.getAppOverlayIn : '',
//         ]
//           .filter(Boolean)
//           .join(' ')}
//         onClick={onClose}
//       >
//         <div
//           className={[
//             styles.getAppModal,
//             entered ? styles.getAppModalIn : '',
//           ]
//             .filter(Boolean)
//             .join(' ')}
//           onClick={(e) => e.stopPropagation()}
//         >
//           {/* Close */}
//           <button
//             type="button"
//             className={styles.getAppClose}
//             onClick={onClose}
//             aria-label="Close"
//           >
//             ✕
//           </button>

//           {/* ── LEFT PANEL ── */}
//           <div className={styles.getAppLeft}>
//             <div className={styles.getAppLeftOrb1} />
//             <div className={styles.getAppLeftOrb2} />
//             <div className={styles.getAppLeftOrb3} />

//             {[...Array(6)].map((_, i) => (
//               <span
//                 key={i}
//                 className={styles.getAppParticle}
//                 style={{ '--pi': i }}
//               />
//             ))}

//             <div className={styles.getAppLeftTag}>📱 Mobile App</div>

//             <PhoneMockup />

//             <p className={styles.getAppTagline}>
//               Book courts · Join tournaments<br />
//               <span>Track scores · All in one app.</span>
//             </p>

//             <div className={styles.getAppLeftStats}>
//               {[
//                 { num: '50K+', label: 'Downloads'   },
//                 { num: '12K+', label: 'Active Users' },
//                 { num: '4.8★', label: 'Rating'       },
//               ].map((s) => (
//                 <div key={s.label} className={styles.getAppLeftStat}>
//                   <span className={styles.getAppLeftStatNum}>{s.num}</span>
//                   <span className={styles.getAppLeftStatLabel}>{s.label}</span>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* ── RIGHT PANEL ── */}
//           <div className={styles.getAppRight}>

//             <div className={styles.getAppRightBadge}>
//               <span className={styles.getAppLiveDot} />
//               Available on iOS &amp; Android
//             </div>

//             <h2 className={styles.getAppTitle}>Download the App</h2>
//             <p className={styles.getAppSubtitle}>
//               Your sports companion — courts, coaches, and
//               tournaments at your fingertips.
//             </p>

//             {/* QR */}
//             <div className={styles.getAppQrBlock}>
//               <div className={styles.getAppQrFrame}>
//                 <div className={styles.getAppQrCornerTL} />
//                 <div className={styles.getAppQrCornerTR} />
//                 <div className={styles.getAppQrCornerBL} />
//                 <div className={styles.getAppQrCornerBR} />
//                 <div className={styles.getAppQrScanLine} />
//                 <img
//                   src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https%3A%2F%2Fsportsmaster.app%2Fdownload&color=0f172a&bgcolor=f8fafc&qzone=2&margin=5"
//                   alt="Scan to download SportsMaster"
//                   className={styles.getAppQrImg}
//                   loading="lazy"
//                 />
//               </div>
//               <p className={styles.getAppQrHint}>📷 Scan with your phone camera</p>
//             </div>

//             {/* OR divider */}
//             <div className={styles.getAppOrRow}>
//               <div className={styles.getAppOrLine} />
//               <span className={styles.getAppOrText}>or download directly</span>
//               <div className={styles.getAppOrLine} />
//             </div>

//             {/* Store buttons */}
//             <div className={styles.getAppStores}>

//               {/* Google Play */}
//               <a
//                 href="https://play.google.com/store"
//                 target="_blank"
//                 rel="noreferrer"
//                 className={styles.storeBtn}
//                 aria-label="Get it on Google Play"
//               >
//                 <span className={styles.storeBtnIcon}>
//                   <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
//                     <path d="M3.18 23.76c.38.22.82.24 1.22.04l13.2-7.62-2.84-2.84-11.58 10.42zm-1.18-21.06v18.6a1.5 1.5 0 0 0 .76 1.32l12.46-11.12L2.76 1.38a1.5 1.5 0 0 0-.76 1.32zm19.52 7.68-2.96-1.72-3.14 3.14 3.14 3.14 3-.74a2 2 0 0 0 0-3.82zm-17.16-9.14 11.58 10.42 2.84-2.84-13.2-7.62a1.34 1.34 0 0 0-1.22.04z" />
//                   </svg>
//                 </span>
//                 <div className={styles.storeBtnMeta}>
//                   <span className={styles.storeBtnSub}>GET IT ON</span>
//                   <span className={styles.storeBtnName}>Google Play</span>
//                   <StarRating value={4.8} count="50K reviews" />
//                 </div>
//                 <span className={styles.storeBtnArrow}>→</span>
//               </a>

//               {/* App Store */}
//               <a
//                 href="https://apps.apple.com"
//                 target="_blank"
//                 rel="noreferrer"
//                 className={[styles.storeBtn, styles.storeBtnApple].join(' ')}
//                 aria-label="Download on the App Store"
//               >
//                 <span className={styles.storeBtnIcon}>
//                   <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
//                     <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
//                   </svg>
//                 </span>
//                 <div className={styles.storeBtnMeta}>
//                   <span className={styles.storeBtnSub}>DOWNLOAD ON</span>
//                   <span className={styles.storeBtnName}>App Store</span>
//                   <StarRating value={4.9} count="30K reviews" />
//                 </div>
//                 <span className={styles.storeBtnArrow}>→</span>
//               </a>
//             </div>

//             {/* Feature tags */}
//             <div className={styles.getAppFeatureTags}>
//               {STORE_FEATURES.map((tag) => (
//                 <span key={tag} className={styles.getAppFeatureTag}>
//                   {tag}
//                 </span>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </Portal>
//   );
// };


// /* ═══════════════════════════════════════════════════
//    LOGOUT POPUP
// ═══════════════════════════════════════════════════ */
// const LogoutPopup = ({ onConfirm, onCancel }) => (
//   <Portal>
//     <div className={styles.popupOverlay} onClick={onCancel}>
//       <div
//         className={styles.popupCard}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className={styles.waveHandWrap}>
//           <span className={styles.waveHand}>👋</span>
//         </div>
//         <h3 className={styles.popupTitle}>Leaving so soon?</h3>
//         <p className={styles.popupMsg}>
//           Are you sure you want to logout from{' '}
//           <span className={styles.popupAccent}>SportsMaster</span>?
//         </p>
//         <div className={styles.popupActions}>
//           <button
//             type="button"
//             className={styles.popupCancel}
//             onClick={onCancel}
//           >
//             Stay
//           </button>
//           <button
//             type="button"
//             className={styles.popupConfirm}
//             onClick={onConfirm}
//           >
//             Yes, Logout
//           </button>
//         </div>
//       </div>
//     </div>
//   </Portal>
// );


// /* ═══════════════════════════════════════════════════
//    LOGIN REQUIRED POPUP
// ═══════════════════════════════════════════════════ */
// const LoginRequiredPopup = ({ label, redirectTo, onClose }) => {
//   const navigate      = useNavigate();
//   const isTournaments = redirectTo === '/my-tournaments';

//   const handleLogin = useCallback(() => {
//     sessionStorage.setItem('pendingNavRedirect', redirectTo);
//     navigate('/login?redirect=' + redirectTo);
//     onClose();
//   }, [navigate, redirectTo, onClose]);

//   const handleSignUp = useCallback(() => {
//     sessionStorage.setItem('pendingNavRedirect', redirectTo);
//     navigate('/register?redirect=' + redirectTo);
//     onClose();
//   }, [navigate, redirectTo, onClose]);

//   return (
//     <Portal>
//       <div className={styles.popupOverlay} onClick={onClose}>
//         <div
//           className={styles.popupCard}
//           onClick={(e) => e.stopPropagation()}
//         >
//           {/* Contextual animation */}
//           {isTournaments ? (
//             <div className={styles.trophyWrap}>
//               <div className={styles.trophyRing3} />
//               <div className={styles.trophyRing2} />
//               <div className={styles.trophyRing1} />
//               <div className={styles.trophyCore} />
//               <div className={styles.trophySparkWrap}>
//                 {[0, 1, 2, 3, 4, 5].map((i) => (
//                   <div
//                     key={i}
//                     className={styles.trophySpark}
//                     style={{ '--si': i }}
//                   />
//                 ))}
//               </div>
//             </div>
//           ) : (
//             <div className={styles.cardFanWrap}>
//               <div className={[styles.fanCard, styles.fanCard3].join(' ')} />
//               <div className={[styles.fanCard, styles.fanCard2].join(' ')} />
//               <div className={[styles.fanCard, styles.fanCard1].join(' ')} />
//               <div className={styles.fanDot1} />
//               <div className={styles.fanDot2} />
//               <div className={styles.fanDot3} />
//             </div>
//           )}

//           <h3 className={styles.popupTitle}>Login Required</h3>
//           <p className={styles.popupMsg}>
//             You need to be logged in to access{' '}
//             <span className={styles.popupAccent}>{label}</span>
//           </p>

//           <div className={styles.popupActions}>
//             <button
//               type="button"
//               className={styles.popupCancel}
//               onClick={onClose}
//             >
//               Cancel
//             </button>
//             <button
//               type="button"
//               className={styles.popupConfirm}
//               onClick={handleLogin}
//             >
//               Login Now →
//             </button>
//           </div>

//           <p className={styles.popupHint}>
//             Don&apos;t have an account?{' '}
//             <span
//               className={styles.popupHintLink}
//               role="button"
//               tabIndex={0}
//               onClick={handleSignUp}
//               onKeyDown={(e) => e.key === 'Enter' && handleSignUp()}
//             >
//               Sign up free
//             </span>
//           </p>
//         </div>
//       </div>
//     </Portal>
//   );
// };


// /* ═══════════════════════════════════════════════════
//    HAMBURGER
// ═══════════════════════════════════════════════════ */
// const Hamburger = ({ open, onClick }) => (
//   <button
//     type="button"
//     className={[
//       styles.hamburger,
//       open ? styles.hamburgerOpen : '',
//     ]
//       .filter(Boolean)
//       .join(' ')}
//     onClick={onClick}
//     aria-label={open ? 'Close menu' : 'Open menu'}
//     aria-expanded={open}
//   >
//     <span className={styles.bar} />
//     <span className={styles.bar} />
//     <span className={styles.bar} />
//   </button>
// );


// /* ═══════════════════════════════════════════════════
//    NAVBAR
// ═══════════════════════════════════════════════════ */
// const Navbar = () => {
//   const { user, isAuthenticated, logout } = useAuth();
//   const navigate = useNavigate();

//   /* ── UI state ── */
//   const [dropdownOpen,    setDropdownOpen]    = useState(false);
//   const [mobileOpen,      setMobileOpen]      = useState(false);
//   const [showLogout,      setShowLogout]      = useState(false);
//   const [authPrompt,      setAuthPrompt]      = useState(null);
//   const [notifications,   setNotifications]   = useState(MOCK_NOTIFICATIONS);
//   const [mobileNotifOpen, setMobileNotifOpen] = useState(false);
//   const [getAppOpen,      setGetAppOpen]      = useState(false);

//   const unreadCount = notifications.filter((n) => !n.read).length;

//   /* ── Refs ── */
//   const menuRef        = useRef(null);
//   const mobileRef      = useRef(null);
//   const mobileNotifRef = useRef(null);

//   /* ── Outside click: avatar dropdown ── */
//   useEffect(() => {
//     const h = (e) => {
//       if (menuRef.current && !menuRef.current.contains(e.target))
//         setDropdownOpen(false);
//     };
//     document.addEventListener('mousedown', h);
//     return () => document.removeEventListener('mousedown', h);
//   }, []);

//   /* ── Outside click: mobile drawer ── */
//   useEffect(() => {
//     const h = (e) => {
//       if (mobileRef.current && !mobileRef.current.contains(e.target))
//         setMobileOpen(false);
//     };
//     document.addEventListener('mousedown', h);
//     return () => document.removeEventListener('mousedown', h);
//   }, []);

//   /* ── Outside click: mobile notif ── */
//   useEffect(() => {
//     if (!mobileNotifOpen) return;
//     const h = (e) => {
//       if (
//         mobileNotifRef.current &&
//         !mobileNotifRef.current.contains(e.target)
//       ) setMobileNotifOpen(false);
//     };
//     document.addEventListener('mousedown', h);
//     return () => document.removeEventListener('mousedown', h);
//   }, [mobileNotifOpen]);

//   // Listen for voice agent "get app" command
// useEffect(() => {
//   const handler = () => setGetAppOpen(true);
//   window.addEventListener('open-get-app', handler);
//   return () => window.removeEventListener('open-get-app', handler);
// }, []);

//   /* ── Escape key: close all ── */
//   useEffect(() => {
//     const fn = (e) => {
//       if (e.key !== 'Escape') return;
//       setShowLogout(false);
//       setAuthPrompt(null);
//       setMobileOpen(false);
//       setDropdownOpen(false);
//       setMobileNotifOpen(false);
//       setGetAppOpen(false);
//     };
//     window.addEventListener('keydown', fn);
//     return () => window.removeEventListener('keydown', fn);
//   }, []);

//   /* ── Body scroll lock ── */
//   useEffect(() => {
//     document.body.style.overflow =
//       mobileOpen || getAppOpen ? 'hidden' : '';
//     return () => { document.body.style.overflow = ''; };
//   }, [mobileOpen, getAppOpen]);

//   /* ── Redirect after login ── */
//   useEffect(() => {
//     if (!isAuthenticated) return;
//     const pending = sessionStorage.getItem('pendingNavRedirect');
//     if (!pending) return;
//     sessionStorage.removeItem('pendingNavRedirect');
//     navigate(pending);
//   }, [isAuthenticated, navigate]);

//   /* ── Handlers ── */
//   const handleLogoutClick = useCallback(() => {
//     setDropdownOpen(false);
//     setMobileOpen(false);
//     setShowLogout(true);
//   }, []);

//   const handleConfirmLogout = useCallback(() => {
//     setShowLogout(false);
//     logout();
//   }, [logout]);

//   const handleProtectedClick = useCallback(
//     (e, link) => {
//       if (!isAuthenticated) {
//         e.preventDefault();
//         setMobileOpen(false);
//         setAuthPrompt({ label: link.label, redirectTo: link.to });
//       }
//     },
//     [isAuthenticated]
//   );

//   const desktopLinkClass = useCallback(
//     ({ isActive }, link) =>
//       [
//         styles.navItem,
//         isActive ? styles.navItemActive : '',
//         link.protected && !isAuthenticated ? styles.navItemLocked : '',
//       ]
//         .filter(Boolean)
//         .join(' '),
//     [isAuthenticated]
//   );

//   const drawerLinkClass = useCallback(
//     ({ isActive }, link) =>
//       [
//         styles.drawerItem,
//         isActive ? styles.drawerItemActive : '',
//         link.protected && !isAuthenticated ? styles.drawerItemLocked : '',
//       ]
//         .filter(Boolean)
//         .join(' '),
//     [isAuthenticated]
//   );

//   /* ───────────────────────────────────────
//      RENDER
//   ─────────────────────────────────────── */
//   return (
//     <>
//       {/* ══════════════════════════════════
//           NAVBAR
//       ══════════════════════════════════ */}
//       <nav className={styles.navbar}>

//         {/* Brand */}
//         <Link
//           to="/"
//           className={styles.brand}
//           onClick={() => setMobileOpen(false)}
//         >
//           <span className={styles.brandIcon}>🏀</span>
//           <span className={styles.brandText}>SportsMaster</span>
//         </Link>

//         {/* ── Desktop Nav Links ── */}
//         <ul className={styles.navLinks}>
//           {NAV_LINKS.map((link) => (
//             <li key={link.to}>
//               <NavLink
//                 to={link.to}
//                 end={link.to === '/'}
//                 className={(s) => desktopLinkClass(s, link)}
//                 onClick={(e) =>
//                   link.protected && handleProtectedClick(e, link)
//                 }
//               >
//                 {link.label}
//                 {link.protected && !isAuthenticated && ' 🔒'}
//               </NavLink>
//             </li>
//           ))}

//           {/* Get App — separated with divider */}
//           <li className={styles.navGetAppSeparator}>
//             <button
//               type="button"
//               className={styles.getAppNavBtn}
//               onClick={() => setGetAppOpen(true)}
//             >
//               Get App
//             </button>
//           </li>
//         </ul>

//         {/* ── Desktop Auth + Bell ── */}
//         <div className={styles.authActions}>
//           {isAuthenticated ? (
//             <>
//               <NotifBell
//                 notifications={notifications}
//                 onNotifChange={setNotifications}
//               />

//               <div className={styles.userMenu} ref={menuRef}>
//                 <div
//                   className={styles.avatar}
//                   role="button"
//                   tabIndex={0}
//                   onClick={() => setDropdownOpen((p) => !p)}
//                   onKeyDown={(e) =>
//                     e.key === 'Enter' && setDropdownOpen((p) => !p)
//                   }
//                   title={user?.name}
//                   aria-label="User menu"
//                 >
//                   {user?.name?.[0]?.toUpperCase()}
//                 </div>

//                 {dropdownOpen && (
//                   <div className={styles.dropdown}>
//                     {/* Profile */}
//                     <Link
//                       to="/profile"
//                       onClick={() => setDropdownOpen(false)}
//                     >
//                       <UserIcon size={14} />
//                       My Profile
//                     </Link>

//                     {/* Logout */}
//                     <button type="button" onClick={handleLogoutClick}>
//                       <LogoutIcon size={14} />
//                       Logout
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </>
//           ) : (
//             <Link to="/login" className={styles.btnAuth}>
//               Login / Register
//             </Link>
//           )}
//         </div>

//         {/* ── Mobile Right Cluster ── */}
//         <div className={styles.mobileRight}>
//           {isAuthenticated && (
//             <button
//               type="button"
//               className={[
//                 styles.notifBell,
//                 mobileNotifOpen ? styles.notifBellActive : '',
//               ]
//                 .filter(Boolean)
//                 .join(' ')}
//               onClick={() => setMobileNotifOpen((p) => !p)}
//               aria-label="Notifications"
//             >
//               <BellIcon size={15} />
//               {unreadCount > 0 && (
//                 <span className={styles.notifBadge}>
//                   {unreadCount > 9 ? '9+' : unreadCount}
//                 </span>
//               )}
//             </button>
//           )}

//           <Hamburger
//             open={mobileOpen}
//             onClick={() => setMobileOpen((p) => !p)}
//           />
//         </div>
//       </nav>


//       {/* ══════════════════════════════════
//           MOBILE NOTIFICATION SHEET
//       ══════════════════════════════════ */}
//       {isAuthenticated && mobileNotifOpen && (
//         <Portal>
//           <div
//             className={styles.mobileNotifOverlay}
//             onClick={() => setMobileNotifOpen(false)}
//           />
//           <div
//             className={styles.mobileNotifSheet}
//             ref={mobileNotifRef}
//           >
//             <NotificationPanel
//               notifications={notifications}
//               onRead={(id) =>
//                 setNotifications((p) =>
//                   p.map((n) => (n.id === id ? { ...n, read: true } : n))
//                 )
//               }
//               onReadAll={() =>
//                 setNotifications((p) =>
//                   p.map((n) => ({ ...n, read: true }))
//                 )
//               }
//               onClose={() => setMobileNotifOpen(false)}
//             />
//           </div>
//         </Portal>
//       )}


//       {/* ══════════════════════════════════
//           MOBILE BACKDROP
//       ══════════════════════════════════ */}
//       <div
//         className={[
//           styles.mobileBackdrop,
//           mobileOpen ? styles.mobileBackdropOpen : '',
//         ]
//           .filter(Boolean)
//           .join(' ')}
//         onClick={() => setMobileOpen(false)}
//         aria-hidden="true"
//       />


//       {/* ══════════════════════════════════
//           MOBILE DRAWER
//       ══════════════════════════════════ */}
//       <aside
//         ref={mobileRef}
//         className={[
//           styles.mobileDrawer,
//           mobileOpen ? styles.mobileDrawerOpen : '',
//         ]
//           .filter(Boolean)
//           .join(' ')}
//         aria-hidden={!mobileOpen}
//       >
//         {/* Header */}
//         <div className={styles.drawerHeader}>
//           <Link
//             to="/"
//             className={styles.brand}
//             onClick={() => setMobileOpen(false)}
//           >
//             <span className={styles.brandIcon}>🏀</span>
//             <span className={styles.brandText}>SportsMaster</span>
//           </Link>
//           <button
//             type="button"
//             className={styles.drawerClose}
//             onClick={() => setMobileOpen(false)}
//             aria-label="Close menu"
//           >
//             ✕
//           </button>
//         </div>

//         {/* Links */}
//         <ul className={styles.drawerLinks}>
//           {NAV_LINKS.map((link) => (
//             <li key={link.to}>
//               <NavLink
//                 to={link.to}
//                 end={link.to === '/'}
//                 className={(s) => drawerLinkClass(s, link)}
//                 onClick={(e) => {
//                   if (link.protected && !isAuthenticated) {
//                     handleProtectedClick(e, link);
//                   } else {
//                     setMobileOpen(false);
//                   }
//                 }}
//               >
//                 <span className={styles.drawerItemLabel}>{link.label}</span>
//                 {link.protected && !isAuthenticated && (
//                   <span className={styles.drawerLock}>🔒</span>
//                 )}
//               </NavLink>
//             </li>
//           ))}

//           {/* Get App */}
//           <li>
//             <div className={styles.drawerGetAppDivider} />
//             <button
//               type="button"
//               className={styles.drawerGetAppBtn}
//               onClick={() => {
//                 setMobileOpen(false);
//                 setGetAppOpen(true);
//               }}
//             >
//               <span className={styles.drawerItemLabel}>Get App</span>
//               <span className={styles.drawerGetAppPill}>FREE</span>
//             </button>
//           </li>
//         </ul>

//         {/* Footer */}
//         <div className={styles.drawerFooter}>
//           {isAuthenticated ? (
//             <>
//               <Link
//                 to="/profile"
//                 className={styles.drawerProfileBtn}
//                 onClick={() => setMobileOpen(false)}
//               >
//                 <span className={styles.drawerAvatar}>
//                   {user?.name?.[0]?.toUpperCase()}
//                 </span>
//                 <span>{user?.name}</span>
//               </Link>
//               <button
//                 type="button"
//                 className={styles.drawerLogoutBtn}
//                 onClick={handleLogoutClick}
//               >
//                 <LogoutIcon size={15} />
//                 Logout
//               </button>
//             </>
//           ) : (
//             <Link
//               to="/login"
//               className={styles.drawerAuthBtn}
//               onClick={() => setMobileOpen(false)}
//             >
//               Login / Register
//             </Link>
//           )}
//         </div>
//       </aside>


//       {/* ══════════════════════════════════
//           POPUPS
//       ══════════════════════════════════ */}
//       {showLogout && (
//         <LogoutPopup
//           onConfirm={handleConfirmLogout}
//           onCancel={() => setShowLogout(false)}
//         />
//       )}

//       {authPrompt && (
//         <LoginRequiredPopup
//           label={authPrompt.label}
//           redirectTo={authPrompt.redirectTo}
//           onClose={() => setAuthPrompt(null)}
//         />
//       )}

//       {getAppOpen && (
//         <GetAppPopup onClose={() => setGetAppOpen(false)} />
//       )}
//     </>
//   );
// };

// export default Navbar;
import { useState, useRef, useEffect, useCallback } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { useAuth } from '../../../hooks/useAuth';
import styles from './Navbar.module.scss';
import logo from '../../assests/logo5.png';



/* ═══════════════════════════════════════════════════
   STATIC DATA
═══════════════════════════════════════════════════ */
const NAV_LINKS = [
  { to: '/', label: 'Home', protected: false },
  { to: '/courts', label: 'Courts', protected: false },
  { to: '/tournaments', label: 'Tournaments', protected: false },
  { to: '/coaches', label: 'Book a Coach', protected: false },
  { to: '/book-one-on-one', label: 'Book 1-on-1', protected: false },
  { to: '/live-matches', label: 'Live Matches', protected: false },
  { to: '/my-tournaments', label: 'My Tournaments', protected: true },
  { to: '/my-bookings', label: 'My Bookings', protected: true },
];

const MOCK_NOTIFICATIONS = [
  {
    id: 1,
    type: 'court_approved',
    icon: '🏟️',
    title: 'Court Booking Approved',
    message: 'Your booking for Badminton Court A on Apr 2 has been approved by the vendor.',
    time: '2 min ago',
    read: false,
  },
  {
    id: 2,
    type: 'tournament_registered',
    icon: '🏆',
    title: 'Tournament Registration Confirmed',
    message: 'You have successfully registered for the Summer Badminton Championship 2026.',
    time: '15 min ago',
    read: false,
  },
  {
    id: 3,
    type: 'coach_approved',
    icon: '🎯',
    title: 'Coach Session Approved',
    message: 'Coach Rahul has accepted your 1-on-1 session request for Saturday, 10 AM.',
    time: '1 hr ago',
    read: false,
  },
  {
    id: 4,
    type: 'player_registered',
    icon: '👤',
    title: 'Player Profile Verified',
    message: 'Your player profile has been verified. You can now join ranked tournaments.',
    time: '3 hr ago',
    read: true,
  },
  {
    id: 5,
    type: 'court_rejected',
    icon: '❌',
    title: 'Court Booking Rejected',
    message: 'Your booking for Tennis Court B on Apr 5 was declined. Please choose another slot.',
    time: 'Yesterday',
    read: true,
  },
  {
    id: 6,
    type: 'tournament_registered',
    icon: '🏆',
    title: 'Tournament Draw Published',
    message: 'The draw for Spring Table Tennis Open is live. Check your bracket now.',
    time: '2 days ago',
    read: true,
  },
];

const STORE_FEATURES = ['✓ Free Download', '✓ No Ads', '✓ Live Scores'];



/* ═══════════════════════════════════════════════════
   PORTAL
═══════════════════════════════════════════════════ */
const Portal = ({ children }) =>
  ReactDOM.createPortal(children, document.body);



/* ═══════════════════════════════════════════════════
   ICONS
═══════════════════════════════════════════════════ */
const BellIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const UserIcon = ({ size = 15 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const LogoutIcon = ({ size = 15 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);



/* ═══════════════════════════════════════════════════
   NOTIFICATION PANEL
═══════════════════════════════════════════════════ */
const NotificationPanel = ({
  notifications,
  onRead,
  onReadAll,
  onClose,
  panelRef,
}) => {
  const unreadCount = notifications.filter((n) => !n.read).length;

  return (
    <div className={styles.notifPanel} ref={panelRef}>
      <div className={styles.notifHeader}>
        <div className={styles.notifHeaderLeft}>
          <span className={styles.notifTitle}>Notifications</span>
          {unreadCount > 0 && (
            <span className={styles.notifHeaderBadge}>{unreadCount} new</span>
          )}
        </div>

        {unreadCount > 0 && (
          <button
            type="button"
            className={styles.notifMarkAll}
            onClick={onReadAll}
          >
            Mark all read
          </button>
        )}
      </div>

      <ul className={styles.notifList}>
        {notifications.length === 0 ? (
          <li className={styles.notifEmpty}>
            <span className={styles.notifEmptyIcon}>🔔</span>
            <span>No notifications yet</span>
          </li>
        ) : (
          notifications.map((n) => (
            <li
              key={n.id}
              className={[
                styles.notifItem,
                !n.read ? styles.notifItemUnread : '',
              ]
                .filter(Boolean)
                .join(' ')}
              onClick={() => onRead(n.id)}
            >
              <div
                className={[
                  styles.notifIconWrap,
                  styles[`notifType_${n.type}`],
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                {n.icon}
              </div>

              <div className={styles.notifBody}>
                <p className={styles.notifItemTitle}>{n.title}</p>
                <p className={styles.notifItemMsg}>{n.message}</p>
                <span className={styles.notifTime}>{n.time}</span>
              </div>

              {!n.read && <span className={styles.notifDot} />}
            </li>
          ))
        )}
      </ul>

      {notifications.length > 0 && (
        <div className={styles.notifFooter}>
          <Link
            to="/notifications"
            className={styles.notifViewAll}
            onClick={onClose}
          >
            View all notifications →
          </Link>
        </div>
      )}
    </div>
  );
};



/* ═══════════════════════════════════════════════════
   NOTIFICATION BELL (desktop)
═══════════════════════════════════════════════════ */
const NotifBell = ({ notifications, onNotifChange }) => {
  const [open, setOpen] = useState(false);
  const bellRef = useRef(null);
  const panelRef = useRef(null);
  const unreadCount = notifications.filter((n) => !n.read).length;

  useEffect(() => {
    const handler = (e) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(e.target) &&
        bellRef.current &&
        !bellRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className={styles.notifWrap} ref={bellRef}>
      <button
        type="button"
        className={[
          styles.notifBell,
          open ? styles.notifBellActive : '',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={() => setOpen((p) => !p)}
        aria-label="Notifications"
      >
        <BellIcon size={16} />
        {unreadCount > 0 && (
          <span className={styles.notifBadge}>
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {open && (
        <NotificationPanel
          notifications={notifications}
          panelRef={panelRef}
          onRead={(id) =>
            onNotifChange((p) =>
              p.map((n) => (n.id === id ? { ...n, read: true } : n))
            )
          }
          onReadAll={() =>
            onNotifChange((p) => p.map((n) => ({ ...n, read: true })))
          }
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
};



/* ═══════════════════════════════════════════════════
   PHONE MOCKUP
═══════════════════════════════════════════════════ */
const PhoneMockup = () => (
  <div className={styles.phoneMockupWrap}>
    <div className={styles.phoneRing3} />
    <div className={styles.phoneRing2} />
    <div className={styles.phoneRing1} />

    <div className={styles.phone}>
      <div className={styles.phoneNotch} />
      <div className={styles.phoneScreen}>
        <div className={styles.phoneStatusBar}>
          <span>9:41</span>
          <span>●●●</span>
        </div>
        <div className={styles.phoneHeader}>
          <img
            src={logo}
            alt="SportsMaster"
            className={styles.phoneHeaderLogo}
          />
        </div>
        <div className={styles.phoneBanner} />
        <div className={styles.phoneCardRow}>
          <div className={styles.phoneMiniCard} />
          <div className={styles.phoneMiniCard} />
        </div>
        <div className={styles.phoneCardLong} />
        <div
          className={styles.phoneCardLong}
          style={{ opacity: 0.5, width: '70%' }}
        />
      </div>
      <div className={styles.phoneBottomNav}>
        {['🏠', '🏟️', '🏆', '👤'].map((ic, i) => (
          <span
            key={i}
            className={[
              styles.phoneNavIcon,
              i === 0 ? styles.phoneNavIconActive : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {ic}
          </span>
        ))}
      </div>
    </div>

    <div className={styles.phoneGlow} />
  </div>
);



/* ═══════════════════════════════════════════════════
   STAR RATING
═══════════════════════════════════════════════════ */
const StarRating = ({ value, count }) => (
  <div className={styles.storeStarsRow}>
    <div className={styles.storeStarsInner}>
      {[1, 2, 3, 4, 5].map((s) => (
        <span
          key={s}
          className={[
            styles.storeStar,
            s <= Math.floor(value)
              ? styles.storeStarFull
              : s - 0.5 <= value
              ? styles.storeStarHalf
              : styles.storeStarEmpty,
          ]
            .filter(Boolean)
            .join(' ')}
          style={{ '--delay': `${s * 0.08}s` }}
        >
          ★
        </span>
      ))}
    </div>
    <span className={styles.storeStarVal}>{value}</span>
    <span className={styles.storeStarCount}>({count})</span>
  </div>
);



/* ═══════════════════════════════════════════════════
   GET APP POPUP
═══════════════════════════════════════════════════ */
const GetAppPopup = ({ onClose }) => {
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setEntered(true), 30);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const fn = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', fn);
    return () => window.removeEventListener('keydown', fn);
  }, [onClose]);

  return (
    <Portal>
      <div
        className={[
          styles.getAppOverlay,
          entered ? styles.getAppOverlayIn : '',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={onClose}
      >
        <div
          className={[
            styles.getAppModal,
            entered ? styles.getAppModalIn : '',
          ]
            .filter(Boolean)
            .join(' ')}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            className={styles.getAppClose}
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>

          <div className={styles.getAppLeft}>
            <div className={styles.getAppLeftOrb1} />
            <div className={styles.getAppLeftOrb2} />
            <div className={styles.getAppLeftOrb3} />

            {[...Array(6)].map((_, i) => (
              <span
                key={i}
                className={styles.getAppParticle}
                style={{ '--pi': i }}
              />
            ))}

            <div className={styles.getAppLeftTag}>📱 Mobile App</div>

            <PhoneMockup />

            <p className={styles.getAppTagline}>
              Book courts · Join tournaments
              <br />
              <span>Track scores · All in one app.</span>
            </p>

            <div className={styles.getAppLeftStats}>
              {[
                { num: '50K+', label: 'Downloads' },
                { num: '12K+', label: 'Active Users' },
                { num: '4.8★', label: 'Rating' },
              ].map((s) => (
                <div key={s.label} className={styles.getAppLeftStat}>
                  <span className={styles.getAppLeftStatNum}>{s.num}</span>
                  <span className={styles.getAppLeftStatLabel}>{s.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.getAppRight}>
            <div className={styles.getAppRightBadge}>
              <span className={styles.getAppLiveDot} />
              Available on iOS &amp; Android
            </div>

            <h2 className={styles.getAppTitle}>Download the App</h2>
            <p className={styles.getAppSubtitle}>
              Your sports companion — courts, coaches, and tournaments at your
              fingertips.
            </p>

            <div className={styles.getAppQrBlock}>
              <div className={styles.getAppQrFrame}>
                <div className={styles.getAppQrCornerTL} />
                <div className={styles.getAppQrCornerTR} />
                <div className={styles.getAppQrCornerBL} />
                <div className={styles.getAppQrCornerBR} />
                <div className={styles.getAppQrScanLine} />
                <img
                  src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https%3A%2F%2Fsportsmaster.app%2Fdownload&color=0f172a&bgcolor=f8fafc&qzone=2&margin=5"
                  alt="Scan to download SportsMaster"
                  className={styles.getAppQrImg}
                  loading="lazy"
                />
              </div>
              <p className={styles.getAppQrHint}>📷 Scan with your phone camera</p>
            </div>

            <div className={styles.getAppOrRow}>
              <div className={styles.getAppOrLine} />
              <span className={styles.getAppOrText}>or download directly</span>
              <div className={styles.getAppOrLine} />
            </div>

            <div className={styles.getAppStores}>
              <a
                href="https://play.google.com/store"
                target="_blank"
                rel="noreferrer"
                className={styles.storeBtn}
                aria-label="Get it on Google Play"
              >
                <span className={styles.storeBtnIcon}>
                  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                    <path d="M3.18 23.76c.38.22.82.24 1.22.04l13.2-7.62-2.84-2.84-11.58 10.42zm-1.18-21.06v18.6a1.5 1.5 0 0 0 .76 1.32l12.46-11.12L2.76 1.38a1.5 1.5 0 0 0-.76 1.32zm19.52 7.68-2.96-1.72-3.14 3.14 3.14 3.14 3-.74a2 2 0 0 0 0-3.82zm-17.16-9.14 11.58 10.42 2.84-2.84-13.2-7.62a1.34 1.34 0 0 0-1.22.04z" />
                  </svg>
                </span>
                <div className={styles.storeBtnMeta}>
                  <span className={styles.storeBtnSub}>GET IT ON</span>
                  <span className={styles.storeBtnName}>Google Play</span>
                  <StarRating value={4.8} count="50K reviews" />
                </div>
                <span className={styles.storeBtnArrow}>→</span>
              </a>

              <a
                href="https://apps.apple.com"
                target="_blank"
                rel="noreferrer"
                className={[styles.storeBtn, styles.storeBtnApple].join(' ')}
                aria-label="Download on the App Store"
              >
                <span className={styles.storeBtnIcon}>
                  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                  </svg>
                </span>
                <div className={styles.storeBtnMeta}>
                  <span className={styles.storeBtnSub}>DOWNLOAD ON</span>
                  <span className={styles.storeBtnName}>App Store</span>
                  <StarRating value={4.9} count="30K reviews" />
                </div>
                <span className={styles.storeBtnArrow}>→</span>
              </a>
            </div>

            <div className={styles.getAppFeatureTags}>
              {STORE_FEATURES.map((tag) => (
                <span key={tag} className={styles.getAppFeatureTag}>
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};



/* ═══════════════════════════════════════════════════
   LOGOUT POPUP
═══════════════════════════════════════════════════ */
const LogoutPopup = ({ onConfirm, onCancel }) => (
  <Portal>
    <div className={styles.popupOverlay} onClick={onCancel}>
      <div className={styles.popupCard} onClick={(e) => e.stopPropagation()}>
        <div className={styles.waveHandWrap}>
          <span className={styles.waveHand}>👋</span>
        </div>
        <h3 className={styles.popupTitle}>Leaving so soon?</h3>
        <p className={styles.popupMsg}>
          Are you sure you want to logout from{' '}
          <span className={styles.popupAccent}>SportsMaster</span>?
        </p>
        <div className={styles.popupActions}>
          <button
            type="button"
            className={styles.popupCancel}
            onClick={onCancel}
          >
            Stay
          </button>
          <button
            type="button"
            className={styles.popupConfirm}
            onClick={onConfirm}
          >
            Yes, Logout
          </button>
        </div>
      </div>
    </div>
  </Portal>
);



/* ═══════════════════════════════════════════════════
   LOGIN REQUIRED POPUP
═══════════════════════════════════════════════════ */
const LoginRequiredPopup = ({ label, redirectTo, onClose }) => {
  const navigate = useNavigate();
  const isTournaments = redirectTo === '/my-tournaments';

  const handleLogin = useCallback(() => {
    sessionStorage.setItem('pendingNavRedirect', redirectTo);
    navigate('/login?redirect=' + redirectTo);
    onClose();
  }, [navigate, redirectTo, onClose]);

  const handleSignUp = useCallback(() => {
    sessionStorage.setItem('pendingNavRedirect', redirectTo);
    navigate('/register?redirect=' + redirectTo);
    onClose();
  }, [navigate, redirectTo, onClose]);

  return (
    <Portal>
      <div className={styles.popupOverlay} onClick={onClose}>
        <div className={styles.popupCard} onClick={(e) => e.stopPropagation()}>
          {isTournaments ? (
            <div className={styles.trophyWrap}>
              <div className={styles.trophyRing3} />
              <div className={styles.trophyRing2} />
              <div className={styles.trophyRing1} />
              <div className={styles.trophyCore} />
              <div className={styles.trophySparkWrap}>
                {[0, 1, 2, 3, 4, 5].map((i) => (
                  <div
                    key={i}
                    className={styles.trophySpark}
                    style={{ '--si': i }}
                  />
                ))}
              </div>
            </div>
          ) : (
            <div className={styles.cardFanWrap}>
              <div className={[styles.fanCard, styles.fanCard3].join(' ')} />
              <div className={[styles.fanCard, styles.fanCard2].join(' ')} />
              <div className={[styles.fanCard, styles.fanCard1].join(' ')} />
              <div className={styles.fanDot1} />
              <div className={styles.fanDot2} />
              <div className={styles.fanDot3} />
            </div>
          )}

          <h3 className={styles.popupTitle}>Login Required</h3>
          <p className={styles.popupMsg}>
            You need to be logged in to access{' '}
            <span className={styles.popupAccent}>{label}</span>
          </p>

          <div className={styles.popupActions}>
            <button
              type="button"
              className={styles.popupCancel}
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className={styles.popupConfirm}
              onClick={handleLogin}
            >
              Login Now →
            </button>
          </div>

          <p className={styles.popupHint}>
            Don&apos;t have an account?{' '}
            <span
              className={styles.popupHintLink}
              role="button"
              tabIndex={0}
              onClick={handleSignUp}
              onKeyDown={(e) => e.key === 'Enter' && handleSignUp()}
            >
              Sign up free
            </span>
          </p>
        </div>
      </div>
    </Portal>
  );
};



/* ═══════════════════════════════════════════════════
   HAMBURGER
═══════════════════════════════════════════════════ */
const Hamburger = ({ open, onClick }) => (
  <button
    type="button"
    className={[
      styles.hamburger,
      open ? styles.hamburgerOpen : '',
    ]
      .filter(Boolean)
      .join(' ')}
    onClick={onClick}
    aria-label={open ? 'Close menu' : 'Open menu'}
    aria-expanded={open}
  >
    <span className={styles.bar} />
    <span className={styles.bar} />
    <span className={styles.bar} />
  </button>
);



/* ═══════════════════════════════════════════════════
   NAVBAR
═══════════════════════════════════════════════════ */
const Navbar = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [authPrompt, setAuthPrompt] = useState(null);
  const [notifications, setNotifications] = useState(MOCK_NOTIFICATIONS);
  const [mobileNotifOpen, setMobileNotifOpen] = useState(false);
  const [getAppOpen, setGetAppOpen] = useState(false);

  const unreadCount = notifications.filter((n) => !n.read).length;

  const menuRef = useRef(null);
  const mobileRef = useRef(null);
  const mobileNotifRef = useRef(null);

  useEffect(() => {
    const h = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  useEffect(() => {
    const h = (e) => {
      if (mobileRef.current && !mobileRef.current.contains(e.target)) {
        setMobileOpen(false);
      }
    };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  useEffect(() => {
    if (!mobileNotifOpen) return;

    const h = (e) => {
      if (
        mobileNotifRef.current &&
        !mobileNotifRef.current.contains(e.target)
      ) {
        setMobileNotifOpen(false);
      }
    };

    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [mobileNotifOpen]);

  useEffect(() => {
    const handler = () => setGetAppOpen(true);
    window.addEventListener('open-get-app', handler);
    return () => window.removeEventListener('open-get-app', handler);
  }, []);

  useEffect(() => {
    const fn = (e) => {
      if (e.key !== 'Escape') return;
      setShowLogout(false);
      setAuthPrompt(null);
      setMobileOpen(false);
      setDropdownOpen(false);
      setMobileNotifOpen(false);
      setGetAppOpen(false);
    };

    window.addEventListener('keydown', fn);
    return () => window.removeEventListener('keydown', fn);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen || getAppOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen, getAppOpen]);

  useEffect(() => {
    if (!isAuthenticated) return;
    const pending = sessionStorage.getItem('pendingNavRedirect');
    if (!pending) return;
    sessionStorage.removeItem('pendingNavRedirect');
    navigate(pending);
  }, [isAuthenticated, navigate]);

  const handleLogoutClick = useCallback(() => {
    setDropdownOpen(false);
    setMobileOpen(false);
    setShowLogout(true);
  }, []);

  const handleConfirmLogout = useCallback(() => {
    setShowLogout(false);
    logout();
  }, [logout]);

  const handleProtectedClick = useCallback(
    (e, link) => {
      if (!isAuthenticated) {
        e.preventDefault();
        setMobileOpen(false);
        setAuthPrompt({ label: link.label, redirectTo: link.to });
      }
    },
    [isAuthenticated]
  );

  const desktopLinkClass = useCallback(
    ({ isActive }, link) =>
      [
        styles.navItem,
        isActive ? styles.navItemActive : '',
        link.protected && !isAuthenticated ? styles.navItemLocked : '',
      ]
        .filter(Boolean)
        .join(' '),
    [isAuthenticated]
  );

  const drawerLinkClass = useCallback(
    ({ isActive }, link) =>
      [
        styles.drawerItem,
        isActive ? styles.drawerItemActive : '',
        link.protected && !isAuthenticated ? styles.drawerItemLocked : '',
      ]
        .filter(Boolean)
        .join(' '),
    [isAuthenticated]
  );

  return (
    <>
      <nav className={styles.navbar}>
        <Link
          to="/"
          className={styles.brand}
          onClick={() => setMobileOpen(false)}
          aria-label="SportsMaster Home"
        >
          <img src={logo} alt="SportsMaster" className={styles.brandLogo} />
        </Link>

        <ul className={styles.navLinks}>
          {NAV_LINKS.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                end={link.to === '/'}
                className={(s) => desktopLinkClass(s, link)}
                onClick={(e) =>
                  link.protected && handleProtectedClick(e, link)
                }
              >
                {link.label}
                {link.protected && !isAuthenticated && ' 🔒'}
              </NavLink>
            </li>
          ))}

          <li className={styles.navGetAppSeparator}>
            <button
              type="button"
              className={styles.getAppNavBtn}
              onClick={() => setGetAppOpen(true)}
            >
              Get App
            </button>
          </li>
        </ul>

        <div className={styles.authActions}>
          {isAuthenticated ? (
            <>
              <NotifBell
                notifications={notifications}
                onNotifChange={setNotifications}
              />

              <div className={styles.userMenu} ref={menuRef}>
                <div
                  className={styles.avatar}
                  role="button"
                  tabIndex={0}
                  onClick={() => setDropdownOpen((p) => !p)}
                  onKeyDown={(e) =>
                    e.key === 'Enter' && setDropdownOpen((p) => !p)
                  }
                  title={user?.name}
                  aria-label="User menu"
                >
                  {user?.name?.[0]?.toUpperCase()}
                </div>

                {dropdownOpen && (
                  <div className={styles.dropdown}>
                    <Link
                      to="/profile"
                      onClick={() => setDropdownOpen(false)}
                    >
                      <UserIcon size={14} />
                      My Profile
                    </Link>

                    <button type="button" onClick={handleLogoutClick}>
                      <LogoutIcon size={14} />
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <Link to="/login" className={styles.btnAuth}>
              Login / Register
            </Link>
          )}
        </div>

        <div className={styles.mobileRight}>
          {isAuthenticated && (
            <button
              type="button"
              className={[
                styles.notifBell,
                mobileNotifOpen ? styles.notifBellActive : '',
              ]
                .filter(Boolean)
                .join(' ')}
              onClick={() => setMobileNotifOpen((p) => !p)}
              aria-label="Notifications"
            >
              <BellIcon size={15} />
              {unreadCount > 0 && (
                <span className={styles.notifBadge}>
                  {unreadCount > 9 ? '9+' : unreadCount}
                </span>
              )}
            </button>
          )}

          <Hamburger
            open={mobileOpen}
            onClick={() => setMobileOpen((p) => !p)}
          />
        </div>
      </nav>

      {isAuthenticated && mobileNotifOpen && (
        <Portal>
          <div
            className={styles.mobileNotifOverlay}
            onClick={() => setMobileNotifOpen(false)}
          />
          <div
            className={styles.mobileNotifSheet}
            ref={mobileNotifRef}
          >
            <NotificationPanel
              notifications={notifications}
              onRead={(id) =>
                setNotifications((p) =>
                  p.map((n) => (n.id === id ? { ...n, read: true } : n))
                )
              }
              onReadAll={() =>
                setNotifications((p) =>
                  p.map((n) => ({ ...n, read: true }))
                )
              }
              onClose={() => setMobileNotifOpen(false)}
            />
          </div>
        </Portal>
      )}

      <div
        className={[
          styles.mobileBackdrop,
          mobileOpen ? styles.mobileBackdropOpen : '',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={() => setMobileOpen(false)}
        aria-hidden="true"
      />

      <aside
        ref={mobileRef}
        className={[
          styles.mobileDrawer,
          mobileOpen ? styles.mobileDrawerOpen : '',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-hidden={!mobileOpen}
      >
        <div className={styles.drawerHeader}>
          <Link
            to="/"
            className={styles.brand}
            onClick={() => setMobileOpen(false)}
            aria-label="SportsMaster Home"
          >
            <img src={logo} alt="SportsMaster" className={styles.brandLogo} />
          </Link>

          <button
            type="button"
            className={styles.drawerClose}
            onClick={() => setMobileOpen(false)}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <ul className={styles.drawerLinks}>
          {NAV_LINKS.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                end={link.to === '/'}
                className={(s) => drawerLinkClass(s, link)}
                onClick={(e) => {
                  if (link.protected && !isAuthenticated) {
                    handleProtectedClick(e, link);
                  } else {
                    setMobileOpen(false);
                  }
                }}
              >
                <span className={styles.drawerItemLabel}>{link.label}</span>
                {link.protected && !isAuthenticated && (
                  <span className={styles.drawerLock}>🔒</span>
                )}
              </NavLink>
            </li>
          ))}

          <li>
            <div className={styles.drawerGetAppDivider} />
            <button
              type="button"
              className={styles.drawerGetAppBtn}
              onClick={() => {
                setMobileOpen(false);
                setGetAppOpen(true);
              }}
            >
              <span className={styles.drawerItemLabel}>Get App</span>
              <span className={styles.drawerGetAppPill}>FREE</span>
            </button>
          </li>
        </ul>

        <div className={styles.drawerFooter}>
          {isAuthenticated ? (
            <>
              <Link
                to="/profile"
                className={styles.drawerProfileBtn}
                onClick={() => setMobileOpen(false)}
              >
                <span className={styles.drawerAvatar}>
                  {user?.name?.[0]?.toUpperCase()}
                </span>
                <span>{user?.name}</span>
              </Link>

              <button
                type="button"
                className={styles.drawerLogoutBtn}
                onClick={handleLogoutClick}
              >
                <LogoutIcon size={15} />
                Logout
              </button>
            </>
          ) : (
            <Link
              to="/login"
              className={styles.drawerAuthBtn}
              onClick={() => setMobileOpen(false)}
            >
              Login / Register
            </Link>
          )}
        </div>
      </aside>

      {showLogout && (
        <LogoutPopup
          onConfirm={handleConfirmLogout}
          onCancel={() => setShowLogout(false)}
        />
      )}

      {authPrompt && (
        <LoginRequiredPopup
          label={authPrompt.label}
          redirectTo={authPrompt.redirectTo}
          onClose={() => setAuthPrompt(null)}
        />
      )}

      {getAppOpen && (
        <GetAppPopup onClose={() => setGetAppOpen(false)} />
      )}
    </>
  );
};

export default Navbar;